<template>
  <div>
    <div class="content">
      <div class="top">易贷码查询</div>
      <div class="from">
        <el-form ref="form" :model="form" :inline="true">
          <el-form-item label="需求编号">
            <el-input v-model="form.reqNo" clearable style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="区域">
            <el-select v-model="form.belongArea" clearable style="width:150px">
              <el-option v-for="item in belongAreaArr" :key="item.id" :label="item.label" :value="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布日期">
            <el-date-picker
            style="width: 300px;"
            v-model="timeArr"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="queryInfo">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tab">
        <el-table :data="applyProList" style="width: 100%">
          <el-table-column prop="reqNo" :align="'center'" label="需求编号" width="180">
            <template slot-scope="scope">{{scope.row.reqNo}}</template>
          </el-table-column>
          <el-table-column prop="enterpriseName" :align="'center'" label="企业名称" width="250">
            <template slot-scope="scope">{{scope.row.enterpriseName}}</template>
          </el-table-column>
          <el-table-column prop="orgCode" :align="'center'" label="社会信用代码" width="200">
            <template slot-scope="scope">{{scope.row.orgCode}}</template>
          </el-table-column>
          <el-table-column prop="belongArea" :align="'center'" label="区域" width="100">
            <template slot-scope="scope">{{scope.row.belongArea}}</template>
          </el-table-column>
          <el-table-column prop="createTime" :align="'center'" label="发布日期" width="120">
            <template slot-scope="scope">{{scope.row.createTime.split('T')[0]}}</template>
          </el-table-column>
          <el-table-column prop="financeAmt" :align="'center'" label="融资金额(万元)" width="120">
            <template slot-scope="scope">{{scope.row.financeAmt}}</template>
          </el-table-column>
          <el-table-column prop="contactsPhone" :align="'center'" label="联系人手机号" width="150">
            <template slot-scope="scope">{{scope.row.contactsPhone}}</template>
          </el-table-column>
          <el-table-column prop="contactsPhone" :align="'center'" label="意向银行1-银行名称" v-if="getSourceType == 4" width="200">
            <template slot-scope="scope">{{scope.row.bankList[0].financeName}}</template>
          </el-table-column>
          <el-table-column prop="contactsPhone" :align="'center'" label="意向银行1-对接时间" v-if="getSourceType == 4" width="200">
            <template slot-scope="scope">{{getBankTime(0,scope.row)}}</template>
          </el-table-column>
          <el-table-column prop="contactsPhone" :align="'center'" label="意向银行1-对接状态" v-if="getSourceType == 4" width="200">
            <template slot-scope="scope">{{getBankStatus(0,scope.row)}}</template>
          </el-table-column>
          <el-table-column prop="contactsPhone" :align="'center'" label="意向银行2-银行名称" v-if="getSourceType == 4" width="200">
            <template slot-scope="scope">{{getBankName(1,scope.row)}}</template>
          </el-table-column>
          <el-table-column prop="contactsPhone" :align="'center'" label="意向银行2-对接时间" v-if="getSourceType == 4" width="200">
            <template slot-scope="scope">{{getBankTime(1,scope.row)}}</template>
          </el-table-column>
          <el-table-column prop="contactsPhone" :align="'center'" label="意向银行2-对接状态" v-if="getSourceType == 4" width="200">
            <template slot-scope="scope">{{getBankStatus(1,scope.row)}}</template>
          </el-table-column>
          <el-table-column prop="contactsPhone" :align="'center'" label="意向银行3-银行名称" v-if="getSourceType == 4" width="200">
            <template slot-scope="scope">{{getBankName(2,scope.row)}}</template>
          </el-table-column>
          <el-table-column prop="contactsPhone" :align="'center'" label="意向银行3-对接时间" v-if="getSourceType == 4" width="200">
            <template slot-scope="scope">{{getBankTime(2,scope.row)}}</template>
          </el-table-column>
          <el-table-column prop="contactsPhone" :align="'center'" label="意向银行3-对接状态" v-if="getSourceType == 4" width="200">
            <template slot-scope="scope">{{getBankStatus(2,scope.row)}}</template>
          </el-table-column>
          <el-table-column prop="creditAmtSum" :align="'center'" label="授信金额(万元)" v-if="getSourceType == 4" width="200">
            <template slot-scope="scope">{{scope.row.creditAmtSum?scope.row.creditAmtSum:'-'}}</template>
          </el-table-column>
          
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next"
            :total="this.total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ydmReqList, reqListByBank } from '@/api/ydm'
export default {
  props:{
    getSourceType: String,
  },
  data() {
    return {
      belongAreaArr:[
        {
          id:1,
          label:'高新区'
        },
        {
          id:2,
          label:'工业园区'
        },
        {
          id:3,
          label:'相城区'
        },
        {
          id:4,
          label:'太仓市'
        },
        {
          id:5,
          label:'姑苏区'
        },
        {
          id:6,
          label:'吴中区'
        },
        {
          id:7,
          label:'昆山市'
        },
        {
          id:8,
          label:'张家港市'
        },
        {
          id:9,
          label:'吴江区'
        },
        {
          id:10,
          label:'常熟市'
        }
      ],
      timeArr:null,
      form: {
        reqNo:'',
        startDate:'',
        endDate:'',
        belongArea:'',
        page: 1,
        size: 10
      },
      registereFrom: {},
      applyProList: [],
      total: 0
    };
  },
  created() {
    this.getcheckinListList();
  },
  methods: {
    getBankStatus(num, row){
      if(row.bankList[num] && row.bankList[num].reqStatus!= null){
        return row.bankList[num].reqStatus
      }else{
        return '-'
      }
    },
    getBankTime(num, row){
      if(row.bankList[num] && row.bankList[num].opTime != null){
        return row.bankList[num].opTime
      }else{
        return '-'
      }
    },
    getBankName(num, row){
      if(row.bankList[num] && row.bankList[num].financeName != null){
        return row.bankList[num].financeName
      }else{
        return '-'
      }
    },
    // 查询
    queryInfo() {
      this.form.page = 1
      this.getcheckinListList();
    },
    search() {
      this.getcheckinListList();
    },
    async getcheckinListList() {
      let searchForm = {
        ...this.form
      }
      if(this.timeArr != null){
        searchForm.startDate=this.timeArr[0]
        searchForm.endDate=this.timeArr[1]
      }else{
        searchForm.startDate=''
        searchForm.endDate=''
      }
      if(this.getSourceType == 1){ 
        // 金融机构
        searchForm.enterpriseName = sessionStorage.getItem('userName')
        ydmReqList(searchForm).then(res=>{
          if(res.data.code == 200){
            this.applyProList = res.data.data.list;
            this.total = res.data.data.total;
          }else{
            this.$message.error(res.data.msg)
          }
        })
      }else if(this.getSourceType == 2){ 
        // 金融机构
        reqListByBank(searchForm).then(res=>{
          if(res.data.code == 200){
            this.applyProList = res.data.data.list;
            this.total = res.data.data.total;
          }else{
            this.$message.error(res.data.msg)
          }
        })
      }else if(this.getSourceType == 4){
        // 监管机构
        ydmReqList(searchForm).then(res=>{
          if(res.data.code == 200){
            this.applyProList = res.data.data.list;
            this.total = res.data.data.total;
          }else{
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.getcheckinListList();
    }
  }
};
</script>
<style lang='less' scoped>
.content {
  min-height: 894px;
  margin-top: 10px;
  background-color: #fff;
  border-radius: 8px;
  padding-top: 10px;
  padding-bottom: 20px;
  width: 1050px;
  .top {
    height: 30px;
    border-left: 8px solid #2981ee;
    padding-left: 38px;
    box-sizing: border-box;
    font-size: 22px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #2981ee;
    line-height: 30px;
  }
  .from {
    margin-top: 37px;
    margin-left: 38px;
  }
  .dowm {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding-right: 40px;
    box-sizing: border-box;
    /deep/ .el-button {
      width: 157px;
      height: 40px;
      background: #2981ee;
      border-radius: 6px;
      color: #fff;
    }
  }
  .tab {
    box-sizing: border-box;
    margin-top: 15px;
    min-height: 700px;
    user-select: text;
    .block {
      margin-top: 20px;
      display: flex;
      justify-content: center;
    }
    /deep/ .el-table th {
      background: #f3f4f9;
    }
  }

}
</style> 